import DOMPurify from "dompurify";

const HTML_TAG_RE = /<\/?(p|br|div|ul|ol|li|strong|em|b|i|a|h[1-6]|span)\b[^>]*>/i;

export const isHtml = (value: string): boolean => HTML_TAG_RE.test(value);

export const getDescriptionParts = (value: string | null | undefined) => {
  const raw = value || "";
  const html = isHtml(raw);
  return {
    html,
    // sanitized HTML if it has tags, otherwise the raw plain text
    content: html ? DOMPurify.sanitize(raw) : raw,
    // length of the visible text, so truncation ignores tag characters
    plainLength: html ? raw.replace(/<[^>]*>/g, "").length : raw.length,
  };
};